// extracted by mini-css-extract-plugin
module.exports = {"BackButton":"BackButton_BackButton__2r8OK","Button":"BackButton_Button__1I5re"};